"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapStatusToValue = (status, values) => {
    if (values[status]) {
        return values[status];
    }
    return status;
};
exports.default = mapStatusToValue;
//# sourceMappingURL=map-status-to-value.js.map